<script>
  import BrandLayout from '../components/Layout'
  import News from '@components/List/News'
  import Bulletin from '@components/List/Bulletin'
  import MobileBrandPageTitle from "@components/List/MobileBrandPageTitle";
  import { brandComputed, authComputed } from '@store/helpers'
  import setWindowHistory from "@utils/window-history";
  import DialogLogin from '@components/Dialog/Login';
  import DialogDealer from '@components/Dialog/Dealer';
  import DialogDealerGroup from '@components/Dialog/DealerGroup';

  export default {
    page() {
      return {
        title: `${this.currentBrand.title}`,
      }
    }, 
    components: {
      BrandLayout,
      News,
      Bulletin,
      MobileBrandPageTitle,
      DialogLogin,
      DialogDealer,
      DialogDealerGroup,
      BulletinItem: () => import("@components/List/BulletinItem"),
      NewsItem: () => import("@components/List/NewsItem"),
    },
    props: {
      currentList: {
        type: Array,
        default: () => {
          return []
        },
      },
      featured: {
        type: Array,
        default: () => {
          return []
        },
      },
      pagination: {
        type: Object,
        default: () => {
          return {}
        },
      }
    },
    data() {
      return {
        isDialogLoginVisible: false,
        isDialogDealerVisible: false,
        isDialogDealerGroupVisible: false,
        callbackLogin: () => {
        },
        newsActiveName: this.$route.params.categoryAlias || 'promotion',
        promotion: false,
        bulletin: false,
        newsList: this.currentList || [],
        newsPagination: this.pagination || {},
        featuredList: this.featured || [],
        loadingFetchNewsList:false,
        isChange: false
      }
    },
    computed: {
      ...authComputed,
      formattedNewsList() {
        return this.newsList.map((item) => ({
          title: item.title,
          publish_up: item.publish_up,
          description: item.description,
          introimage: item.introimage,
          brands: item.brands[0],
          extrafields: item.extrafields,
          to: {
            name: 'brand-news-item',
            params: {
              brandAlias: this.$route.params.brandAlias,
              categoryAlias: item.category_alias.split('/')[1],
              newsAlias: item.alias,
            },
          },
          isdealer: item.extrafields.dealer_only.value === "1"
        }))
      },
      formattedFeaturedList() {
        const list = this.featuredList.filter((item) => {
          return item.brands[0].alias === this.$route.params.brandAlias
        })
        if(!list.length) return []
        return list.map((item) => ({
          title: item.title,
          publish_up: item.publish_up,
          description: item.description,
          introimage: item.introimage,
          brands: item.brands[0],
          extrafields: item.extrafields,
          top: true,
          to: {
            name: 'brand-news-item',
            params: {
              brandAlias: this.$route.params.brandAlias,
              categoryAlias: item.category_alias.split('/')[1],
              newsAlias: item.alias,
            },
          },
          isdealer: item.extrafields.dealer_only.value === "1"
        }))
      },
      formattedList() {
        return [...this.formattedFeaturedList, ...this.formattedNewsList]
      },
      tabsNewsMenu() {
        const news = () => this.currentBrand.tabs.filter((item) => {
          return item.alias === 'news'
        })
        return news()[0].children ?? []
      },
      ...brandComputed
    },
    created() {

    },
    methods: {
      onChangePagination(page) {
        this.tryToFetchNewsList({
          storeParams: {
            // ...this.$route.params,
            page
          }
        }).then(() => {
            const url = new URL(window.location)
            let params = url.searchParams;
            if(params.has('page')) {
              this.$scrollToElement({
                $el: this.$refs['sectionList'],
                offset: 260,
              });
            }
        })
      },
      onChangeCategory(tab) {
        if(this.newsActiveName === this.$route.params.categoryAlias) return
        this.loadingFetchNewsList = true 
        this.newsList = [];
        this.isChange = true
        this.$router.replace({
          name: this.$route.name,
          params: {
            categoryAlias: this.newsActiveName
          },
          query: {
            ...this.$route.query,
            page: 1,
          }
        })
        // this.loadingGetData = true;
        // this.
        // const { featured, items, pagination } = await this.$store.dispatch('article/fetchList', {
        //   contentAlias: this.newsActiveName,
        //   params: {
        //     page: 1,
        //     limit: 10,
        //     brand_alias: [this.$route.params.brandAlias]
        //   }
        // })
        //   .finally(() => {
        //     this.loadingGetData = false;
        //   })
        // this.list = items
        // this.paginate = pagination
      },
      async tryToFetchNewsList({ storeParams } = {}) {
        console.log(storeParams)
        this.loadingFetchNewsList = true;
        const params = {
          brand_alias: [this.$route.params.brandAlias],
          limit: 10,
          ...storeParams
        }
        await this.$store.dispatch('article/fetchList', {
          contentAlias: this.$route.params.categoryAlias,
          params
        })
          .then(({items,pagination,featured}) => {
            const setData = () => {
              this.newsList = items;
              this.newsPagination = pagination;
              this.featuredList = featured
            };

            setData();
            
          })
          .finally(() => {
            this.loadingFetchNewsList = false;
          })
      },
      goToView(item) {
        const loggedInFn = () => {
          this.isDialogLoginVisible = false;
          this.$nextTick(() => {
            if(item.isdealer && this.currentMember?.groupId !== 6) {
              this.isDialogDealerGroupVisible = true
            } else {
              this.$router.push(item.to)
            }
          })
        };

        if(this.loggedIn) {
          loggedInFn()
        } else {
          this.callbackLogin = () => {
            loggedInFn()
          };
          this.isDialogDealerVisible = true
        }
      },
      showLogin(val) {
        this.isDialogLoginVisible = val
        this.isDialogDealerVisible = false
      }
    }
  }
</script>
<template>
  <BrandLayout>
    <section :class="$style.sectionNewsList" class="section ">
      <div class="container">
        <BaseSectionTitle 
          title="最新消息" 
          class="text-center d-md-block d-none"
        />
        <MobileBrandPageTitle
          title="最新消息"
          class="d-md-none mt-md-4 mt-5 isNoHasFilter"
        />
        <div ref="sectionList">
          <el-tabs 
            v-model="newsActiveName"
            stretch
            class="isStyleBase"
            @tab-click="onChangeCategory"
          >
            <template v-for="(item, $index) in tabsNewsMenu">
              <template v-if="item.alias === 'promotion'">
                <el-tab-pane
                  :key="$index" 
                  v-loading="loadingFetchNewsList" 
                  label="促銷訊息" 
                  name="promotion"
                >
                  <div style="min-height: 100px">
                    <div v-if="formattedFeaturedList.length" class="row">
                      <div
                        v-for="(item, $index2 ) in formattedFeaturedList"
                        :key="$index2"
                        class="col-12"
                      >
                        <NewsItem 
                          :item="item"
                          class="featuredListItem"
                          is-row-item
                          custom-class="item-hover-shadow"
                          content-type="news"
                          @goTo="goToView"
                        />
                      </div>
                    </div>
                    <template v-if="formattedNewsList.length">
                      <News :list="formattedNewsList" @goTo="goToView"/>
                      <BasePagination2
                        :pagination="pagination"
                        @change="onChangePagination"
                      />
                    </template>
                    <BaseNull
                      v-else-if="!!formattedList.length && !isChange"
                      content="<p class='my-0'>目前此頁面無資料</p> <p class='mb-0 mt-3'>點擊下方按鈕，探索更多資訊</p>"
                    >
                      <BaseButton
                        :to="{
                          name: 'brand-item',
                          params: {
                            brandAlias: $route.params.brandAlias,
                          },
                        }"
                        class="isStylePrimary isCol4 isRadius mt-5">
                        探索更多資訊
                      </BaseButton>
                    </BaseNull>
                  </div>
                </el-tab-pane>
              </template>
              <template v-if="item.alias === 'bulletin'">
                <el-tab-pane 
                  :key="$index" 
                  v-loading="loadingFetchNewsList"
                  label="品牌新訊" 
                  name="bulletin"
                >
                  <div style="min-height: 100px">
                    <div v-if="formattedFeaturedList.length" class="row">
                      <div
                        v-for="(item, $index2 ) in formattedFeaturedList"
                        :key="$index2"
                        class="col-12"
                      >
                        <BulletinItem 
                          :item="item"
                          is-row-item
                          class="featuredListItem"
                          custom-class="item-hover-shadow"
                          content-type="news"
                          @goTo="goToView"
                        />
                      </div>
                    </div>
                    <template v-if="formattedNewsList.length">
                      
                      <Bulletin :list="formattedNewsList" @goTo="goToView"/>
                      <BasePagination2
                        :pagination="pagination"
                        @change="onChangePagination"
                      />
                    </template>
                    <BaseNull
                      v-else-if="!!formattedList.length && !isChange"
                      content="<p class='my-0'>目前此頁面無資料</p> <p class='mb-0 mt-3'>點擊下方按鈕，探索更多資訊</p>"
                    >
                      <BaseButton
                        :to="{
                          name: 'brand-item',
                          params: {
                            brandAlias: $route.params.brandAlias,
                          },
                        }"
                        class="isStylePrimary isCol4 isRadius mt-5">
                        探索更多資訊
                      </BaseButton>
                    </BaseNull>
                  </div>
                </el-tab-pane>
              </template>
            </template>
          </el-tabs>
        </div>
      </div>
    </section>
    <DialogDealerGroup
      :visible.sync="isDialogDealerGroupVisible"
    />
    <DialogDealer
      :visible.sync="isDialogDealerVisible"
      @isShowlogin="showLogin"
    />
    <DialogLogin
      :visible.sync="isDialogLoginVisible"
      @login="callbackLogin"
    />
  </BrandLayout>
</template>

<style lang="scss" module>
  .sectionNewsList {
    :global {
      .sectionNewsList {
      }
      .featuredListItem {
        margin-bottom: 2rem;
      }
    }
  }
</style>
